module.exports = __webpack_public_path__ + "static/media/LibertadMono-Black.a2ad78ec.woff2";